import styled from '@emotion/styled';
import { Alert, Field, tokens, Text } from '@hotjar/hotsauce';

export const Page = styled.article`
  padding: ${tokens.spacer.x3} ${tokens.spacer.x4};
`;

export const Wrapper = styled.div`
  width: 600px;
`;

export const SectionHeader = styled(Text)`
  margin-bottom: ${tokens.spacer.x3pt5};
`;

export const StyledField = styled(Field)`
  width: 100% !important;
`;

export const AvatarSection = styled.div`
  display: flex;
  flex-direction: row;
  .avatar-content {
    align-items: center;
    display: flex;
    width: 48px;
    margin-right: ${tokens.spacer.x1pt5};
  }
  .upload-button-content {
    button {
      margin-bottom: ${tokens.spacer.x1pt5};
    }
  }
`;

export const DimensionAlert = styled(Alert)`
  background-color: transparent;
  padding: 0;
  border: 0;
  min-height: auto;
`;
